import { useEffect } from 'react';
import { showNotification } from '@navi-toolbox/ui-components';
import { NotificationTemplates } from 'common/components/notification-template-factory/types';
import { ReviewFormFieldError } from 'features/review-form/types';
import { getNotificationsConfig } from '../get-notifications-config';

export const useErrorsNotifications = (
  errors: ReviewFormFieldError[],
  isFirstShow: boolean,
  onErrorShown?: (params: { ruText: string }) => void,
) => {
  const canShowErrors = !isFirstShow && errors.length > 0;
  useEffect(() => {
    if (canShowErrors) {
      const notificationsConfig = getNotificationsConfig();
      errors
        ?.filter((errRecord) => notificationsConfig.has(errRecord.errorKey))
        .map((errRecord) => {
          const snackContent = notificationsConfig.get(errRecord.errorKey);
          const {
            title,
            message,
            hideAfter = 0,
            hasButton,
          } = snackContent ?? {
            title: '',
            message: errRecord.message,
          };
          if (onErrorShown) onErrorShown({ ruText: message });
          showNotification({
            data: {
              title,
              message,
              hideAfter,
              hasButton,
            },
            templateId: NotificationTemplates.ReviewFormError,
          });
        });
    }
  }, [canShowErrors, errors, onErrorShown]);
};
